import config from '@/config'
import Forms, { IMembershipCustomFieldGroup } from '@/models/Forms'
import { useGlobalStore } from '@/store/app'
import BaseService from './BaseService'
import { requests } from './HTTPService'
import { ServiceWithStoreDependencies } from './decorators/serviceDecorators'

const http = requests(config?.COMMUNITIES_SERVER_URL)

@ServiceWithStoreDependencies('groupId')
class FormsServiceCls extends BaseService<Forms> {
  constructor() {
    super(null as any)
  }

  model() {
    return Forms
  }

  get endpoint(): string {
    const appStore = useGlobalStore()
    return `/${appStore.locationId}/groups/${appStore.groupId}/forms`
  }

  async create(data: any): Promise<any> {
    const response = await http.post(`${this.endpoint}`, data)
    return response.data
  }

  async findById(id: string): Promise<any> {
    const response = await http.get(`${this.endpoint}/${id}`)
    return response.data
  }

  async fetchCustomFields(): Promise<IMembershipCustomFieldGroup[]> {
    const response = await http.get(`${this.endpoint}/custom-fields`)
    return response.data
  }
}

// Export singleton instance
export const FormsService = new FormsServiceCls()

// Export type for dependency injection
export type IFormsService = FormsServiceCls

// Export commonly used methods directly
export const { create, update, delete: deleteForm, findById, findAll } = FormsService
